import React, { useState, useEffect } from 'react';
import { profileStore } from 'src/hooks/profile';
import Constants from 'src/helper/Constants';
import Helper from 'src/helper/Helper';
import AxiosIndicatorRunTimeLoader from 'src/component/Global/AxiosIndicatorRunTimeLoader';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const ContactInformationPopup = (props) => {
    const { companyNamePattern, alphaNum } = Constants;
    const { SetStatus, data } = props;

    const [{ profile_user_information, jobFunctionList }, { get_profile_account_information, get_profile_job_function_list }, { set_contact_data }] = profileStore();
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const [pageLoader, setPageLoader] = useState(false);

    const initialModalState = {
        userId: "",
        firstName: "",
        lastName: "",
        mobileNumber: "",
        jobTital: "",
        jobFunction: "",
        companyName: "",
        isActive: true
    };

    const [detailValidation, setDetailValidation] = useState({});
    const [contactDetail, setContactDetail] = useState(initialModalState);


    const messages = {
        'contactInformation': '<b>Your Contact Information</b> has been updated successfully.',
    };


    useEffect(() => {
        async function fetchHere() {
            if (jobFunctionList?.length <= 0) {
                await get_profile_job_function_list();
            }
            const contactData = {
                userId: profile_user_information?.id,
                firstName: profile_user_information?.firstName,
                lastName: profile_user_information?.lastName,
                mobileNumber: profile_user_information?.mobileNumber,
                jobTital: profile_user_information?.jobTital,
                jobFunction: profile_user_information?.jobFunction,
                companyName: profile_user_information?.company,
                isActive: true
            };

            setContactDetail(contactData)
        }
        fetchHere()
    }, [profile_user_information, jobFunctionList])
    const onValueChange = (field, value) => {
        if (detailValidation && Object.keys(detailValidation).length > 0) {
            delete detailValidation[field];
        }

        setContactDetail({ ...contactDetail, [field]: value });

    };

    const onSaveContact = async () => {
        let isValid = onValidateData();
        if (isValid) {
            const payload = {
                userId: contactDetail.userId,
                firstName: contactDetail?.firstName ? contactDetail.firstName.trim() : contactDetail.firstName,
                lastName: contactDetail?.lastName ? contactDetail.lastName.trim() : contactDetail.lastName,
                mobileNumber: contactDetail.mobileNumber,
                jobTital: contactDetail?.jobTital ? contactDetail.jobTital.trim() : contactDetail.jobTital,
                jobFunction: contactDetail.jobFunction,
                companyName: contactDetail?.companyName ? contactDetail.companyName.trim() : contactDetail.companyName,
                isActive: true
            };

            setPageLoader(true);
            await set_contact_data(payload).then(async (res) => {

                if (res) {
                    SetStatus(false)
                    setContactDetail(contactDetail)

                    if (messages[data]) {
                        system_alert_indicator({
                            name: 'profile',
                            message: messages[data],
                            type: "success"
                        })
                    }
                    get_profile_account_information();
                    setPageLoader(false);
                }
            })
        }
    };

    const onValidateData = () => {
        let validationModal = {};
        if ((!Helper.valueIsNotNull(contactDetail.firstName)) || (!Helper.validateRegex(contactDetail.firstName, companyNamePattern)) || (contactDetail.firstName.trim().length > 50 || contactDetail.firstName.trim().length < 3)) {
            validationModal.firstName = "First name must not contain numbers and special characters.";
        }
        if ((!Helper.valueIsNotNull(contactDetail.lastName)) || (!Helper.validateRegex(contactDetail.lastName, companyNamePattern)) || (contactDetail.lastName.trim().length > 50 || contactDetail.lastName.trim().length < 3)) {
            validationModal.lastName = "Last name must not contain numbers and special characters.";
        }
        if (!Helper.valueIsNotNull(contactDetail.mobileNumber) || !Helper.validateRegex(contactDetail.mobileNumber, alphaNum)) {
            validationModal.mobileNumber = "A valid phone number is required";
        }
        if (!Helper.valueIsNotNull(contactDetail.companyName) || !Helper.validateRegex(contactDetail.companyName, companyNamePattern)) {
            validationModal.companyName = "A valid company name is required";
        }
        setDetailValidation(validationModal);
        return Object.keys(validationModal).length === 0;
    };

    return (
        <div className="avnet-modal modal-730">
            {pageLoader && <AxiosIndicatorRunTimeLoader overlay={true} />}
            <div className="avnet-modal-inner">
                <button type="button" className="close" data-dismiss="modal" onClick={() => { SetStatus(false) }}>×</button>
                <div className="modal-header justify-content-center">
                    <h1 className="pcn-modal-heading">Contact Information</h1>
                </div>
                <div className="modal-body">
                    <form>
                        <div className="bs5 row">
                            <div className="col-6">
                                <div className="form-group">
                                    <label htmlFor="firstName" className="d-block">First Name*</label>
                                    <input
                                        type="text"
                                        className={`form-control form-control-sm ${detailValidation.firstName ? "error" : ""}`}
                                        id="firstName"
                                        placeholder="First Name"
                                        name="firstName"
                                        maxLength={20}
                                        minLength={3}
                                        value={contactDetail.firstName}
                                        onChange={({ target: { value } }) => {
                                            const filteredValue = value.replace(/[^a-zA-Z\s]/g, '');
                                            onValueChange("firstName", filteredValue);
                                        }}
                                    />
                                    {detailValidation.firstName && <p className="error">{detailValidation.firstName}</p>}
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="form-group">
                                    <label htmlFor="lastName" className="d-block">Last Name*</label>
                                    <input
                                        type="text"
                                        className={`form-control form-control-sm ${detailValidation.lastName ? "error" : ""}`}
                                        id="lastName"
                                        placeholder="Last Name"
                                        name="lastName"
                                        maxLength={50}
                                        minLength={3}
                                        value={contactDetail.lastName}
                                        onChange={({ target: { value } }) => {
                                            const filteredValue = value.replace(/[^a-zA-Z\s]/g, '');
                                            onValueChange("lastName", filteredValue);
                                        }}
                                    />
                                    {detailValidation.lastName && <p className="error">{detailValidation.lastName}</p>}
                                </div>
                            </div>
                        </div>

                        <div className="bs5 row">
                            <div className="col-6">
                                <div className="form-group">
                                    <label htmlFor="mobileNumber" className="d-block">Phone Number*</label>
                                    <input
                                        type="text"
                                        className={`form-control form-control-sm ${detailValidation.mobileNumber ? "error" : ""}`}
                                        id="mobileNumber"
                                        placeholder="Phone Number"
                                        name="mobileNumber"
                                        maxLength={20}
                                        value={contactDetail.mobileNumber}
                                        onChange={({ target: { value } }) => {
                                            const filteredValue = value.replace(/[^\d()+\-\/\s]/g, ''); // Only allowed characters
                                            onValueChange("mobileNumber", filteredValue)
                                        }}
                                    />
                                    {detailValidation.mobileNumber && <p className="error">{detailValidation.mobileNumber}</p>}
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="form-group">
                                    <label htmlFor="jobTitle" className="d-block">Job Title</label>
                                    <input
                                        type="text"
                                        className='form-control form-control-sm'
                                        id="jobTital"
                                        placeholder="Job Title"
                                        name="jobTitle"
                                        value={contactDetail.jobTital}
                                        onChange={({ target: { value } }) => onValueChange("jobTital", value)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="bs5 row">
                            <div className="col-6">
                                <div className="form-group">
                                    <label htmlFor="jobFunction" className="d-block">Job Function</label>

                                    <select
                                        className='form-control form-control-sm'
                                        name="jobFunction"
                                        value={contactDetail.jobFunction}
                                        onChange={({ target: { value } }) => onValueChange("jobFunction", value)}
                                    >
                                        <option value="">Select a Job Function</option>
                                        {jobFunctionList.map((value, key) => {
                                            return <option key={key} value={value?.appValue}>{value?.appValue}</option>
                                        })}

                                    </select>
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="form-group">
                                    <label htmlFor="companyName" className="d-block">Company Name*</label>
                                    <input
                                        type="text"
                                        className={`form-control form-control-sm ${detailValidation.companyName ? "error" : ""}`}
                                        id="companyName"
                                        placeholder="Company Name"
                                        name="companyName"
                                        maxLength={35}
                                        value={contactDetail.companyName}
                                        onChange={({ target: { value } }) => onValueChange("companyName", value)}
                                    />
                                    {detailValidation.companyName && <p className="error">{detailValidation.companyName}</p>}
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="modal-footer d-flex justify-content-center">
                    <button type="button" className="bs5 btn btn-secondary" onClick={() => SetStatus(false)}>Cancel</button>
                    <button type="button" className="bs5 btn btn-primary" onClick={onSaveContact}>Submit</button>
                </div>
            </div>
        </div>
    );
};

export default ContactInformationPopup;
